import { graphql } from "gql";

const CREATE_MESSAGE_MUTATION = graphql(`
  mutation CreateMessage($messageThreadId: ID!, $input: MessageInput!) {
    createMessage(messageThreadId: $messageThreadId, input: $input) {
      ...Message
    }
  }
`);

export default CREATE_MESSAGE_MUTATION;
